// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h5[data-v-76221496]{font-size:17px;margin:0}", "",{"version":3,"sources":["webpack://./modules/frontend/themes/whocanfixmycar/assets/js/components/Partials/CheckAvailability.vue"],"names":[],"mappings":"AACI,oBACI,cAAA,CACA,QAAR","sourcesContent":["\n    h5 {\n        font-size: 17px;\n        margin: 0;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
